import { isValidDate } from "./dates";
import { parseNumber } from "./strings";

export default {
  required: (v) => !!v || "Campo Obrigatório",
  fullName: (v) =>
    /^\s*\S+(\s+\S+)+\s*$/.test(v) || "Informe seu nome completo",
  email: (v) => /.+@.+\..+/.test(v) || "Informe um e-mail válido",
  phone: (v) => (!!v && v.length === 15) || "Informe um número válido",
  password: (v) =>
    (!!v && v.length >= 8) || "Use 8 caracteres ou mais para sua senha",
  document: (v) =>
    ((formatDocument(v).length === 11 || formatDocument(v).length === 14) &&
      validateDocument(v)) ||
    "Informe uma numeração válida",
  cpf: (v) =>
    (formatDocument(v).length === 11 && validateDocument(v)) ||
    "Informe um CPF válido",
  cnpj: (v) =>
    (formatDocument(v).length === 14 && validateDocument(v)) ||
    "Informe um CNPJ válido",
  zipCode: (v) => v.length === 9 || "Informe um CEP válido",
  birthDate: (v) => isValidDate(v) || "Informe uma data válida",
  legalAge: (v) =>
    isValidDate(v, true) || "Necessário que tenha 18 anos ou mais",
  value: (v) => parseNumber(v) > 0 || "Valor deve ser superior à 0",
  url: (v) =>
    /^(https?:\/\/)?(www\.)?([\w-]+\.)+[\w-]{2,}(\/[^\s]*)?$/.test(v) ||
    "Informe uma URL válida",
};

function validateCPF(cpf) {
  cpf = cpf.replace(/\D/g, "");
  if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;

  let sum = 0,
    remainder;
  for (let i = 0; i < 9; i++) sum += parseInt(cpf.charAt(i)) * (10 - i);
  remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) remainder = 0;
  if (remainder !== parseInt(cpf.charAt(9))) return false;

  sum = 0;
  for (let i = 0; i < 10; i++) sum += parseInt(cpf.charAt(i)) * (11 - i);
  remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) remainder = 0;
  return remainder === parseInt(cpf.charAt(10));
}

function validateCNPJ(cnpj) {
  cnpj = cnpj.replace(/\D/g, "");
  if (cnpj.length !== 14 || /^(\d)\1+$/.test(cnpj)) return false;

  let size = 12,
    sum = 0,
    remainder;
  let weights = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  for (let i = 0; i < size; i++) sum += parseInt(cnpj.charAt(i)) * weights[i];
  remainder = sum % 11;
  let digit1 = remainder < 2 ? 0 : 11 - remainder;

  if (parseInt(cnpj.charAt(12)) !== digit1) return false;

  size = 13;
  weights.unshift(6);
  sum = 0;

  for (let i = 0; i < size; i++) sum += parseInt(cnpj.charAt(i)) * weights[i];
  remainder = sum % 11;
  let digit2 = remainder < 2 ? 0 : 11 - remainder;

  return parseInt(cnpj.charAt(13)) === digit2;
}

function validateDocument(value) {
  value = formatDocument(value);

  if (value.length === 11) return validateCPF(value);
  if (value.length === 14) return validateCNPJ(value);

  return false;
}

function formatDocument(value) {
  return value.replace(/[.\-\/]/g, "");
}
